<template>
  <div>
    <div @click="isClick">
      <!-- 将 v-show 移到外层 div -->
      <div v-show="!isDisplayText">
        <el-date-picker 
          :clearable="false" 
          type="daterange" 
          v-model="checkDate" 
          :editable="false" 
          :readonly="webReadonly" 
          range-separator="" 
          :disabled-date="disabledDate"
          :placeholder="$t('DATEPICKER.FIRSTLABLE')" 
          @change="dateChange"
          class="dateStyle"
        >
        </el-date-picker>
      </div>
      
      <!-- resultSearch 使用-->
      <template v-if="webReadonly && isDisplayText">
        <p class="inout-p">
          <span>{{ $t("DATEPICKER.MCHECKIN") }}</span>
          <span class="lt-color">{{ mCheckInDate }}</span>
        </p>
        <p class="inout-p">
          <span>{{ $t("DATEPICKER.MCHECKOUT") }}</span>
          <span class="lt-color">{{ mCheckOutDate }}</span>
        </p>
      </template>
    </div>
    <div>
      <van-calendar 
        v-model:show="calendarShow"
        safe-area-inset-bottom 
        type="range" 
        @confirm="onConfirm" 
        :default-date="defaultDate" 
        :min-date="minDate" 
        :max-date="maxDate" 
        :formatter="calFormatter" 
        :max-range="maxRange" 
        :range-prompt="$t('SEARCH.CHECKINOUTDATE', { maxDay: $objBaseInfo.maxNights })" 
        color="#fc6640"
      />
    </div>
    <ConfirmBoxs 
      :centerDialogVisible="centerDialogVisible" 
      :confirmMsg="confirmMsg" 
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>

<script>
import ConfirmBoxs from "../components/confirmBoxs.vue";
import { getServerTimeAxios, dateChange, formatDateTime } from "@/utils/utils.js";

export default {
  name: "datePicker",
  components: {
    ConfirmBoxs,
  },
  data() {
    return {
      value1: "",
      confirmMsg: "",
      centerDialogVisible: false,
      tripNum: 0,
      calendarShow: false,
      webReadonly: false,
      defaultDate: [],
      minDate: new Date("2022/01/01"),
      maxDate: new Date("2022/01/30"),
      maxRange: 30,
      mCheckInDate: "", //移动端显示入住时间
      mCheckOutDate: "", //移动端显示离店时间
      
      // 内部管理的日期状态
      internalCheckDate: [],
    };
  },
  props: {
    setValue: {},
    isDisplayText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    firstLable() {
      return this.$t("DATEPICKER.FIRSTLABLE");
    },
    lastLable() {
      return this.$t("DATEPICKER.LASTLABLE");
    },
    // 统一的 checkDate 处理
    checkDate: {
      get() {
        // 优先使用内部状态，如果没有则使用 props
        let checkDate = this.internalCheckDate.length ? this.internalCheckDate : (this.setValue || []);
        this.mCheckInDate = checkDate.length ? formatDateTime(new Date(checkDate[0]), "MM-DD") : "";
        this.mCheckOutDate = checkDate.length ? formatDateTime(new Date(checkDate[1]), "MM-DD") : "";
        return checkDate;
      },
      set(value) {
        this.internalCheckDate = value;
        this.syncDefaultDate(value);
        this.$emit("returnCheckDate", value);
      }
    },
  },
  methods: {
    toDateValue(value) {
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? null : date;
    },
    syncDefaultDate(value) {
      if (Array.isArray(value) && value.length === 2) {
        const startDate = this.toDateValue(value[0]);
        const endDate = this.toDateValue(value[1]);
        if (startDate && endDate) {
          this.defaultDate = [startDate, endDate];
          return;
        }
      }
      this.defaultDate = [];
    },
    calFormatter(day) {
      if (day.type === "start") {
        day.bottomInfo = this.$t("DATEPICKER.CHECKIN");
      } else if (day.type === "end") {
        day.bottomInfo = this.$t("DATEPICKER.CHECKOUT");
      }
      return day;
    },
    isClick() {
      if (this.$objBaseInfo.channelId == "MOBILE") {
        this.calendarShow = true;
      }
    },
    onConfirm(date) {
      this.calendarShow = false;
      this.dateChange(date);
    },
    
    // Element Plus 日期禁用函数
    disabledDate(time) {
      if (!this.$objBaseInfo) return false;
      
      let maxDay = this.$objBaseInfo.maximumDaysAdvance || 360;
      const oneDayMs = 86400000;
      
      // 使用服务器时间或当前时间
      const baseTime = this.minDate ? this.minDate.getTime() : Date.now();
      
      // 禁用今天之前和最大天数之后的日期
      return (
        time.getTime() < baseTime - oneDayMs ||
        time.getTime() > baseTime + maxDay * oneDayMs
      );
    },
    
    setDatePicker() {
      if (this.$objBaseInfo) {
        getServerTimeAxios((res) => {
          let maxDay = this.$objBaseInfo.maximumDaysAdvance || 360;
          this.minDate = new Date(formatDateTime(res, "YYYY-MM-DD"));
          this.maxDate = new Date(dateChange(parseInt(maxDay), new Date(res)));
          
          // 不再需要设置 pickerOptions0，因为使用了独立的 disabledDate 方法
        });
      } else {
        if (this.tripNum < 20) {
          this.tripNum++;
          setTimeout(() => {
            this.setDatePicker();
          }, 1000);
        }
      }
    },
    
    setConfirmFlag() {
      this.centerDialogVisible = false;
    },
    
    dateChange(val) {
      if (val != null) {
        if (new Date(val[1]).getTime() == new Date(val[0]).getTime()) {
          this.confirmMsg = this.$t("SEARCH.CHECKINOUTDATE2");
          this.centerDialogVisible = true;
          this.checkDate = []; // 这里会触发 computed setter
        } else {
          const diffDays = (new Date(val[1]).getTime() - new Date(val[0]).getTime()) / (3600 * 1000 * 24 * 1);
          if (diffDays > this.$objBaseInfo.maxNights || diffDays < 1) {
            this.checkDate = []; // 这里会触发 computed setter
            this.confirmMsg = this.$t("SEARCH.CHECKINOUTDATE", {
              maxDay: this.$objBaseInfo.maxNights,
            });
            this.centerDialogVisible = true;
          } else {
            this.checkDate = val; // 这里会触发 computed setter
          }
        }
      }
    },
  },
  mounted() {
    this.setDatePicker();
    
    // 初始化内部状态
    if (this.setValue && this.setValue.length) {
      this.internalCheckDate = [...this.setValue];
    }
    this.syncDefaultDate(this.checkDate);
    
    //插入开始时间icon
    let firstIcon = document.querySelector(".el-range__icon");
    if (firstIcon) {
      firstIcon.innerHTML = '';
      firstIcon.innerHTML += `<svg class="el-icon-search hotel_input__icon svg-icon">
                  <use xlink:href="#icon-check_in"></use>
              </svg>`;
    }

    //-
    let rangeSeparator = document.querySelector(".el-range-separator");
    if (rangeSeparator) {
      rangeSeparator.innerHTML += `<i style="height: 4.4rem;">
              <svg class="hotel_input__icon">
                  <use xlink:href="#icon-to"></use>
              </svg>
            </i>`;
    }

    //插入结束时间icon
    let keyNode = document.querySelector(".el-date-editor");
    if (keyNode) {
      let lastIcon = document.createElement("i");
      lastIcon.setAttribute("class", "el-input__icon el-range__icon");
      lastIcon.innerHTML = `<svg class="el-icon-search hotel_input__icon svg-icon" style="vertical-align: unset;"><use xlink:href="#icon-check_out"></use></svg>`;
      keyNode.insertBefore(lastIcon, rangeSeparator?.nextElementSibling);

      if (this.$objBaseInfo.channelId == "MOBILE") {
        this.webReadonly = true;
      } else {
        //开始时间加标题
        let inputs = document.getElementsByClassName("el-range-input");
        if (inputs.length > 0) {
          let firstLable = document.createElement("div");
          firstLable.setAttribute("style", "position: relative");
          firstLable.innerHTML =
            '<div class="datePicker_first_lable firstlabel">' +
            this.firstLable +
            "</div>";
          keyNode.insertBefore(firstLable, inputs[0]);

          //结束时间加标题
          let lastLable = document.createElement("div");
          lastLable.setAttribute("style", "position: relative");
          lastLable.innerHTML =
            `<div class="datePicker_last_lable lastlabel">` +
            this.lastLable +
            `</div>`;
          keyNode.insertBefore(lastLable, inputs[1]);
        }
        this.webReadonly = false;
      }
    }
    
    this.maxRange = this.$objBaseInfo.maxNights;
  },
  updated() {
    if (this.$objBaseInfo.channelId == "WEB") {
      let fLabel = document.querySelector(".firstlabel");
      if (fLabel) {
        fLabel.innerHTML = this.firstLable;
      }

      let lLabel = document.querySelector(".lastlabel");
      if (lLabel) {
        lLabel.innerHTML = this.lastLable;
      }
    }
  },
  watch: {
    setValue: {
      handler(newVal) {
        if (!this.internalCheckDate.length) {
          this.syncDefaultDate(newVal);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="stylus" scoped>
@media screen and (min-width: 961px) {
  ::v-deep .el-date-editor .el-range-separator {
    width: 7%;
  }
}
@media screen and (max-width: 960px) {
  .inout-p{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    span:first-child{
      padding-right: 0.3rem;
    }
  }
  .lt-color {
    color: $btn-bg-color;
  }
}
</style>

<style lang="stylus">
@media screen and (min-width: 961px) {
  .datePicker_first_lable {
    position: absolute;
    top: -4rem;
    width: 6.5rem;
    height: 2rem;
    margin-left: 1rem;
  }

  .datePicker_last_lable {
    position: absolute;
    width: 6.5rem;
    top: -4rem;
    margin-left: 1rem;
  }
  .el-date-editor .el-range__icon{
    font-size: 24px!important;
  }
  .dateStyle {
    height: 5.2rem!important;
    line-height: 5rem!important;
    width: 97%!important;
  }
}
@media screen and (max-width: 960px) {
  .dateStyle {
    height: 5rem!important;
    line-height: 5rem!important;
    width: 94%!important;
  }
  .el-date-editor .el-range__icon{
    font-size: 24px!important;
  }
}
</style>